import { NavLink } from 'react-router-dom';
import { useParams } from 'react-router';
import Calendar from '../common/Calendar.react';
import ReadAllArticles from './common/ReadAllArticles.react';
import ArticleSubtitle from './common/ArticleSubtitle.react';
import ArticleBreadcrumbs from './common/ArticleBreadcrumbs.react';
import ArticleParagraph from './common/ArticleParagraph.react';
import ArticleHero from './common/ArticleHero.react';
import ArticleBottomBorder from './common/ArticleBottomBorder.react';
var NewsArticle = function NewsArticle(_ref) {
  var article = _ref.article;
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  var slug = article.slug,
    title = article.title,
    newsDate = article.newsDate;
  return /*#__PURE__*/React.createElement("section", {
    className: "a",
    id: "article-".concat(slug)
  }, /*#__PURE__*/React.createElement(ArticleHero, article), /*#__PURE__*/React.createElement("div", {
    className: "a__body ".concat(articleID ? 'a__body--wide' : '')
  }, /*#__PURE__*/React.createElement(ArticleBreadcrumbs, article), /*#__PURE__*/React.createElement("div", {
    className: "a__title a-news__header"
  }, newsDate && /*#__PURE__*/React.createElement(Calendar, {
    className: "a-news__calendar",
    date: newsDate
  }), title && /*#__PURE__*/React.createElement("span", {
    className: "a-news__header--title"
  }, /*#__PURE__*/React.createElement(NavLink, {
    to: "/news/".concat(slug)
  }, /*#__PURE__*/React.createElement("h1", null, title)))), /*#__PURE__*/React.createElement(ArticleSubtitle, article), /*#__PURE__*/React.createElement(ArticleParagraph, article), /*#__PURE__*/React.createElement(ArticleBottomBorder, article), /*#__PURE__*/React.createElement(ReadAllArticles, {
    title: "Articles"
  })));
};
export default NewsArticle;